module.exports = __webpack_public_path__ + "img/15.a2744534.png";